import {
  getNotifications,
  INotificationsDocument,
  INotificationsMessages,
} from 'API';
import { useAppSelector } from 'Hooks';
import { createContext, FC, useEffect, useState } from 'react';

interface INotificationsContext {
  documents: INotificationsDocument[];
  updates: INotificationsMessages;
}

export const NotificationsContext = createContext<INotificationsContext>({
  documents: [],
  updates: {
    other: [],
  },
});

interface INotificationsProvider {}

export const NotificationsProvider: FC<INotificationsProvider> = (props) => {
  const [documents, setDocuments] = useState<INotificationsDocument[]>([]);
  const [updates, setUpdates] = useState<INotificationsMessages>({
    other: [],
  });

  const imposterId = useAppSelector(
    ({ imposter: { imposterId } }) => imposterId
  );
  const getAndSetNotifications = async () => {
    const notificationsData = await getNotifications();

    if (notificationsData) {
      setDocuments(notificationsData.documents);
      setUpdates(notificationsData.messages);
    }
  };

  useEffect(() => {
    getAndSetNotifications();
  }, [imposterId]);

  return (
    <NotificationsContext.Provider
      value={{
        documents,
        updates,
      }}
    >
      {props.children}
    </NotificationsContext.Provider>
  );
};
